// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"93372649","395":"9911fbcc","466":"2977b620","638":"1e23bd52","738":"1848c217"}[chunkId] + ".chunk.css";
};